import React from 'react'
import PropTypes from 'prop-types'
import { H, P, Grid, Image } from '@farewill/ui'

import { ONLINE_WILL_SUBSCRIPTION_PRICE_IN_POUNDS } from 'config'
import { formatPriceInPounds } from 'lib/formatting/pricing'

const UpdateWill = ({ illustration }) => (
  <Grid container style={{ alignItems: 'center' }}>
    <Grid.Item spanFromM={8}>
      <H size="L" as="h2" decorative>
        Update your will anytime
      </H>
      <P marginFromM={[0, 0, 'S']} maxWidthInColumns={7}>
        Once you’ve finished your will, we offer an unlimited update service.
        For only {formatPriceInPounds(ONLINE_WILL_SUBSCRIPTION_PRICE_IN_POUNDS)}{' '}
        a year, you’ll be able to update your will whenever your circumstances
        change, and get specialist support from our team.
      </P>
    </Grid.Item>
    <Grid.Item spanFromM={4} spanFromL={3} centered centeredFromM={false}>
      <Image
        path={illustration}
        width={200}
        widthFromL={300}
        stretch
        margin={[0, 'auto']}
      />
    </Grid.Item>
  </Grid>
)

UpdateWill.propTypes = {
  illustration: PropTypes.string,
}

UpdateWill.defaultProps = {
  illustration: 'illustrations/cropped/phone-with-hand',
}

export default UpdateWill
